import api from '../utils/api';

class OperatorsApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/operators', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getAllUser = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/operators/user-operator/getAll', {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getGroup = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/operators/group');
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post('/operators', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/operators/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/operators/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/operators/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getAllUserOperator = (data, operator_id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(
          `/operators/user-operator/getAll/${operator_id}`,
          { params: data }
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  deleteUserOperator = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/operators/user-operator/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  createUserOperator = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/operators/add-user`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateUserOperator = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/operators/payment/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/operators/status/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getUserOperator = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/operators/user-operator/user/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateUserOperatorByUser = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(
          `/operators/update-user/company/${id}`,
          data
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const operatorsApi = new OperatorsApi();
export default operatorsApi;
